import { client } from "@nju/http-client";

interface IPatchScanEsimQRCodeProps {
  iccId: string | undefined;
}

export async function patchScanEsimQRCode({
  iccId,
}: IPatchScanEsimQRCodeProps) {
  const env = process.env.NEXT_PUBLIC_APP_ENV;

  const apikey =
    env === "int"
      ? process.env.NEXT_PUBLIC_INT_GATEWAY_APIKEY
      : process.env.NEXT_PUBLIC_DEV_GATEWAY_APIKEY;

  const auth =
    env === "int"
      ? process.env.NEXT_PUBLIC_INT_GATEWAY_AUTH
      : process.env.NEXT_PUBLIC_DEV_GATEWAY_AUTH;

  const result = await client(
    `https://${env}-helpers.dopapp.pl/esims/${iccId}/substate`,
    {
      method: "patch",
      headers: {
        version: "1",
        apikey: `${apikey}`,
        Authorization: `Basic ${auth}`,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      json: {
        subState: "Downloaded",
      },
    },
  );

  return result;
}
